/* eslint-disable no-console */
import _ from 'lodash';

import { OFFLINE_DB } from '../constants/indexedDB.constants';
import {
  deleteOfflineDBValueByKey,
  getAllOfflineDBValues,
  getOfflineDBValueByKey,
  setOfflineDBValue,
} from '../utils/indexedDB.offline.utils';

const {
  OBJECT_STORES: { ENTITIES },
  KEY_PATHS: { ID },
} = OFFLINE_DB;

export class EntitiesDBService {
  static async fetchAllEntities() {
    try {
      const results = await getAllOfflineDBValues(ENTITIES);
      const userCacheKey = localStorage.getItem('userCacheKey');
      const filteredResults = results.filter((value) => value[ID].split(' + ')[1] === userCacheKey);
      return filteredResults.map((value) => ({ ...value, id: value[ID].split(' + ')[0] }));
    } catch (error) {
      console.log('fetchSavedEntities(): catch: ', error);
      throw error;
    }
  }

  static async saveEntity(entity) {
    try {
      return await setOfflineDBValue(ENTITIES, entity);
    } catch (error) {
      console.log('saveEntity(): catch: ', error);
      throw error;
    }
  }

  static async updateEntity(entity) {
    try {
      const entityItem = await getOfflineDBValueByKey(ENTITIES, entity.id);
      const updatedItem = _.merge(entityItem, entity);
      return await setOfflineDBValue(ENTITIES, updatedItem);
    } catch (error) {
      console.log('updateEntity(): catch: ', error);
      throw error;
    }
  }

  static async saveEntityDataAndChanges(entityData) {
    try {
      const entityItem = await getOfflineDBValueByKey(ENTITIES, entityData.id);

      if (_.isNil(entityItem)) {
        return await setOfflineDBValue(ENTITIES, entityData);
      }

      entityItem.requestChanges = entityData.requestChanges;
      entityItem.files = entityData.files;
      entityItem.entity.step.data = entityData.entity.step.data;

      return await setOfflineDBValue(ENTITIES, entityItem);
    } catch (error) {
      console.log('saveEntityDataAndChanges(): catch: ', error);
      throw error;
    }
  }

  static async removeEntity(entityId) {
    try {
      return await deleteOfflineDBValueByKey(ENTITIES, entityId);
    } catch (error) {
      console.log('removeEntity(): catch: ', error);
      throw error;
    }
  }
}
